import { makeContractsRepository } from 'modules/customer/infra/repositories';

import { FetchCustomerContractByIdUseCase } from './implementations/FetchCustomerContractByIdUseCase';

let instance: FetchCustomerContractByIdUseCase | null = null;

export default function makeFetchCustomerContractByIdUseCase() {
  if (!instance) {
    const repository = makeContractsRepository();

    instance = new FetchCustomerContractByIdUseCase(repository);
  }

  return instance;
}
